import React from 'react';
import translations from './translations';
import { useTranslation } from 'utils/i18n';
import './AboutUsTeamMember.css';

/**
 * AboutUsTeamMember Component
 * Team member card component for AboutUs page
 * Extracted from pending_about/pending_AboutUs
 */
const AboutUsTeamMember = ({ member }) => {
  const { language } = useTranslation();
  
  // Get component-specific translations
  const t = (key, defaultValue = '') => {
    const componentTranslations = translations[language] || translations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], componentTranslations);
    return value || defaultValue || key;
  };

  if (!member) return null;

  const hasEmail = member.email && member.email.trim() !== '';
  const hasLinkedIn = member.linkedin && member.linkedin.trim() !== '';

  return (
    <div className="team-member">
      <div className="team-member-image">
        <img src={member.image} alt={member.name} />
      </div>
      <div className="team-member-info">
        <h3>{member.name}</h3>
        <p className="team-member-role">{member.role}</p>
        {member.details && (
          <div className="team-member-details">
            {member.details.map((detail, index) => (
              <p key={index}><strong>{detail.label}:</strong> {detail.value}</p>
            ))}
          </div>
        )}
        <div className="team-member-links">
          {hasEmail && (
            <a 
              href={`mailto:${member.email}`}
              className="team-link"
              aria-label={`Email ${member.name}`}
            >
              {t('email', 'Email')}
            </a>
          )}
          {hasLinkedIn && (
            <a 
              href={member.linkedin}
              className="team-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`LinkedIn profile of ${member.name}`}
            >
              {t('linkedin', 'LinkedIn')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutUsTeamMember;


